import eventBus from "@scripts/services/event-bus"

const selectors = {
  radio: { selector: '[data-purchase-radio]' },
  drawer: { selector: '[data-purchase-drawer]' },
  input: { selector: '[data-purchase-plan-id]' },
  price: { selector: '[data-purchase-price]' },
  compare: { selector: '[data-purchase-compare]' },
  discount: { selector: '[data-purchase-discount]'}
}

class PurchasePlans extends HTMLElement {
  #id
  #data
  #layout
  #plan
  #group
  #compare
  #discount

  constructor() {
    super()

    // this.query = null
    // this.validate = useElementValidator()
    // this.listeners = useListenerManager()

    this.boundChange = this.#handleChange.bind(this)
  }

  connectedCallback() {
    this.#id = this.dataset.purchaseUid
    const script = document.getElementById(`json-data--${this.#id}`)
    this.#data = JSON.parse(script.textContent)
    console.log(this.#data)
    
    this.#layout = this.dataset.purchaseLayout
    this.#plan = this.dataset.plan ?? null
    this.#compare = this.dataset.purchaseShowOriginal === 'true'
    this.#discount = this.dataset.purchaseShowDiscount === 'true'

    // this.state = useState(this.#plan, (curr, prev) => {
    //   this.#plan = curr
    //   this.#provider.plan = curr
    // })

    if (this.#layout === 'compact') delete selectors.drawer
    if (!this.#compare) delete selectors.compare
    if (!this.#discount) delete selectors.discount

    try {
      this.#group = this.querySelector('[data-purchase-recurring]')

      if (!this.#group) throw new Error('SellingPlanUi: missing recurring purchase plan group: data-purchase-recurring')

      this.elements = Object.entries(selectors).reduce((acc, [key, val]) => {
        const element = this.#group.querySelector(val.selector)

        if (!element) throw new Error(`SellingPlanUi: missing required element: ${val.selector}`)

        acc[key] = element
        return acc
      }, {})
      
      this.addEventListener('change', this.boundChange)
    } catch (error) {
      console.error(error)
    }
  }

  // disconnectedCallback() {
  //   this.listeners.removeAll()
  // }

  #handleChange(event) {
    const target = event.target
    const { radio, drawer, input } = this.elements
    const isToggle = 'purchaseRadio' in target.dataset
    let value = null

    if (isToggle) {
      const isActive = target === radio

      if (drawer) this.#toggleDrawer(isActive, radio, drawer)

      input.toggleAttribute('disabled', !isActive)
    } else {
      // const id = parseInt(target.value)
      // console.log(id)
      // const { price, compare_at_price } = this.#getAllocationById(id)

      // this.elements.price.textContent = formatPrice(price)

      // if (this.#compare) {
      //   this.elements.compare.textContent = formatPrice(compare_at_price)
      // }

      // if (this.#discount) {
      //   const amount = target.selectedOptions[0].dataset.purchaseOptionDiscount
      //   this.elements.discount.textContent = amount
      // }
    }

    // value = input.disabled
    //   ? null
    //   : input.value

    // this.state.set(value)
  }

  #toggleDrawer(active, radio, drawer) {
    radio.setAttribute('aria-expanded', String(active))
    drawer.setAttribute('aria-hidden', String(!active))
  }

  #getAllocationById(id) {
    return this.#data.variant.selling_plan_allocations.find((item) => item.selling_plan_id === id)
  }
}

export default PurchasePlans